import { Divider, type SxProps } from "@mui/material";
import Section from "@/components/Section";
import BookingSearchDetails from "./BookingSearchDetails";
import CampgroundHeader from "./CampgroundHeader";

export default function BookingSummary({ sx }: { sx?: SxProps }) {
  return (
    <Section sx={sx}>
      <CampgroundHeader variant="expanded" />
      <Divider sx={{ my: 2 }} />
      <BookingSearchDetails variant="expanded" />
    </Section>
  );
}
